// Helpers for the default date range used by all FCC analytics charts.
// Keeps client-side defaults in sync so cache keys and display match the
// backend default (last 30 days; last 180 days for large transactions).

export interface DateRange {
  date_from: string
  date_to: string
}

export const formatDate = (date: Date): string =>
  date.toISOString().slice(0, 10)

export const defaultDateRange = (days = 30): DateRange => {
  const end = new Date()
  const start = new Date(end)
  start.setUTCDate(start.getUTCDate() - days)
  return {
    date_from: formatDate(start),
    date_to: formatDate(end),
  }
}
